import React, { FunctionComponent, ReactNode, useState } from 'react'
import styled from 'styled-components'
import { pageMaxWidth } from '../styles/page-max-width'
import classNames from 'classnames'
import { SectionHead } from '../components/section-head'
import { SvgMinus, SvgPlus } from '../components/svg'

const Outer = styled.div`
  ${pageMaxWidth}
  padding-top: 8rem;
  padding-bottom: 8rem;
  max-width: 60rem;
  margin-inline: auto;
`

const Inner1 = styled.div`
  margin-top: 4rem;
`

const Text1 = styled.div`
  margin-top: 4rem;
  font-weight: 500;
  font-size: 1.875rem;
  line-height: normal;
  letter-spacing: 0.12em;
  @media (max-width: 40rem){
    font-size: 1.25rem;
  }
`

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`

const ListItem = styled.div`
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  background-color: #fff;
  @media (max-width: 40rem){
    font-size: 0.815rem;
  }
  &.active {
    font-weight: 700;
  }
`

const Container = styled.div`
  margin-top: 2rem;
`


type Faq = {
  q: ReactNode,
  a: ReactNode
}
type FaqGroup = {
  name: string,
  id: string,
  items: Faq[]
}

const faqs:FaqGroup[] = [
  {
    name: 'テキスト',
    id: 'a01',
    items: [
      {
        "q": "他の薬と併用はできますか？",
        "a": "ルイボスティーは降圧剤との併用はお控えいただいております。 グリーンティーに関しましては、 健康食品ですので併用されても問題はございません。 気になる方は医師・薬剤師にご相談をお願いいたします。"
      },
      {
        "q": "いつ飲むと良いですか？",
        "a": "飲むタイミングの指定はございませんが、 ルイボスティーは夕食後やお休み前のリラックスタイムに、 グリーンティーは一日の始まりの一杯として召し上がるのをおすすめしております。"
      },
      {
        "q": "飲み方は？",
        "a": "ティースプーン1杯 (3g) を150mlのお水またはお湯で溶かしてお召し上がりください。"
      },
      {
        "q": "1日で何杯飲んでも良いですか？",
        "a": "健康食品ですので、 目安量より多く飲んでいただいても問題はございませんが、 一度に大量に摂取するとお腹が緩くなる恐れがあります。 体調を見ながら、飲む量はご調整ください。"
      },
      {
        "q": "2つを併用して飲んでもいいですか？",
        "a": "併用していただいても問題はございません。"
      },
      {
        "q": "何歳から飲めますか？",
        "a": "何歳から飲んでいただいても問題はございませんが、 大人の目の届くところでの飲用をおすすめします。"
      },
      {
        "q": "アレルギー物質は入っていますか？",
        "a": "両方とも、りんごがアレルギー物質として入っています。"
      },
      {
        "q": "価格は？",
        "a": "<15日分> 定価：税込2,376円　容量：45g <30日分> 定価：税込4,104円　容量：90g"
      },
      {
        "q": "郵便局留めや営業所止めは利用できますか？",
        "a": <>
          当店は日本郵便でのお届けとなりますが、郵便局留めについては以下の条件がございます。<br />
          <br />
          ■ 郵便局留め可能な配送方法<br />
          ・宅配便（ゆうパック）のみ<br />
          <br />
          ■ 郵便局留め不可の配送方法<br />
          ・ゆうパケット<br />
          ・ゆうパケットプラス<br />
          <br />
          また、日本郵便以外の配送業者（ヤマト運輸、佐川急便など）の営業所止めはお受けできず、ご指定いただいた場合は配送不可となり返送される可能性がございます。<br />
          <br />
          郵便局留め（宅配便のみ）をご希望の場合は、正確な記載方法に従ってご住所をご入力ください。具体的な記載方法については、受取希望の郵便局へ直接お問い合わせいただきますようお願いいたします。<br />
          <br />
          ※不適切な住所表記や対応していない配送方法での郵便局留めをご指定の場合、商品の発送が保留となり、お届けに遅延が生じる場合がございますのでご注意ください。
        </>
      }
    ]
  },
]


type FaqItem = {
  label: ReactNode,
  value: ReactNode
}

type FaqPageProps = {

}
export const FaqPage: FunctionComponent<FaqPageProps> = () => {
  const [activeGroupID, setActiveGroupID] = useState(faqs[0]?.id)
  const activeGroup = faqs.find(fg => fg.id === activeGroupID)
  return <Outer>
    <SectionHead en="FAQ" ja="よくあるご質問" />
    <Inner1>
      {
        faqs.length > 1 && <List>
          {
            faqs.map((fg) => {
              return <ListItem key={fg.id} className={classNames({active: fg.id === activeGroupID})} onClick={() => setActiveGroupID(fg.id)}>
                {fg.name}
              </ListItem>
            })
          }
        </List>
      }
      {
        activeGroup && <>
          <Container>
            {
              activeGroup.items.map(faq => {
                return <Row item={{label: faq.q, value: faq.a}} />
              })
            }
          </Container>
        </>
      }
    </Inner1>
  </Outer>
}


const RowOuter = styled.div`
  transition: padding 0.4s;
`

const Label = styled.div`
  font-size: 1rem;
  line-height: 1.5;
  font-family: var(--sans-serif-font);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  transition: border-bottom-color 0.4s;
  cursor: pointer;
  ${RowOuter}.open & {
    border-bottom-color: transparent;
  }
  ${RowOuter}:not(:first-child) & {
    border-top: 1px solid var(--main-text-color);
  }
`

const Icon = styled.div`
  svg {
    display: block;
    height: 0.875rem;
    width: auto;
  }
`

const Value = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 0.4s, padding 0.4s;
  padding-inline: 1rem;
  ${RowOuter}.open & {
    grid-template-rows: 1fr;
    padding-bottom: 1rem;
  }
`

const ValueInner = styled.div`
  overflow: hidden;
  font-size: 0.875rem;
  line-height: 1.5;
`
type RowProps = {
  item: FaqItem
}
const Row: FunctionComponent<RowProps> = ({item}) => {
  const [open, setOpen] = useState(false)
  return <RowOuter className={classNames({open})}>
    <Label onClick={() => setOpen(v => !v)}>
      {item.label}
      <Icon>
        {open ? <SvgMinus size={14} /> : <SvgPlus size={14} />}
      </Icon>
    </Label>
    <Value>
      <ValueInner>
        {item.value}
      </ValueInner>
    </Value>
  </RowOuter>
}